import { removeIcon } from "store/features/memeGenerator/actions";
import { MemeIconState } from "store/features/memeGenerator/types";
import { useAppDispatch, useAppSelector } from "store/store";

export const useDeleteIcon = () => {
    const activeIcon = useAppSelector((state) =>
        state.memeGenerator.meme?.icons.find((i) => i.state === MemeIconState.ACTIVE),
    );
    const dispatch = useAppDispatch();

    function handleDelete() {
        if (!activeIcon) throw new Error(`handleDelete called when activeIcon is ${activeIcon}`);
        dispatch(removeIcon(activeIcon.id));
    }

    return { activeIcon, handleDelete };
};
